












import { Component, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapActions } from "vuex"
import { Route } from "vue-router";

@Component({
    ...mapGetters(["searchKey", "account"])
})
export default class HeaderSearch extends Vue {
    searchVal: string = "";
    results: AccountBookList.AccountBook[] = [];
    lastQuery: string = "";

    async querySearch(query: string, cb: Function) {
        this.$store.dispatch("changeSerchKey", query);
        if (query != "") {
            let res = await Vue.axios.post("accountbooks/searchaccounts?page=0&&size=7", {
                accounterNo: this.$store.state.account.no,
                query: query.trim(),
                scope: "all",
                searchKey: "",
            });
            for (var i = 0; i < res.data.content.length; i++) {
                res.data.content[i].value = res.data.content[i].bookName;
            }
            this.results = res.data.content;
            cb(this.results);
        } else {
            if (this.lastQuery != "") this.$emit("search");
            cb([]);
        }
        this.lastQuery = query;
    }

    async selectAccountBook(accountBook: AccountBookList.AccountBook) {
        let res = await Vue.axios.get("accountbooks/" + accountBook.id);
        this.$store.dispatch("changeAccounBook", res.data);
        this.$utils.setTaxType(res.data);
        this.$utils.getRemarks();
        this.$router.push("/voucherlist");
        this.$nextTick(() => {
            this.$emit("changeBook");
        })
    }

    placeholder = "";

    @Watch("$route")
    routeChanged(val: Route) {
        this.searchVal = "";
        this.$store.dispatch("clearSearchKey");
        this.$store.dispatch("setTip", {
            text: "",
            left: 0,
            top: 0,
            show: false
        });
        if (this.$store.state.currentIcon !== "管理") {
            this.placeholder = "请输入客户编码或客户名称";
        } else {
            this.placeholder = "请输入会计姓名或账号";
        }
    }

    globalSearch() {
        this.$emit("search");
    }
}
